import React, {ChangeEvent, HTMLInputTypeAttribute, useCallback} from 'react';
function Input({value,  maxLength, onChange
    , prefix, suffix,
    label,
    placeholder,
    name,
    onBlur,
    autoComplete,
    selectOnFocus,
    type,
}:{
    autoComplete?: string,
    name?: string,
    onBlur?: (e: React.FocusEvent<HTMLInputElement>)=>void,
    selectOnFocus?: boolean,
    label?: string,
    placeholder?: string,
    type?: HTMLInputTypeAttribute
    value: string,
    onChange:(val: string)=>void,
    maxLength?: number,
    prefix?: string | React.ReactNode,
    suffix?: string  | React.ReactNode,
}) {
  const changed = useCallback((e: ChangeEvent<HTMLInputElement>)=>{
    if(onChange){
      if(maxLength && e.target.value.length > maxLength) {
        return onChange(e.target.value.substring(0, maxLength));
      }
      onChange(e.target.value)
    }
  },[maxLength, onChange])
  return (
      <Wrapper prefix={prefix} suffix={suffix}>
          {
              label ?
                  <label className="floating-label" htmlFor={name}>
                      <input
                          name={name}
                            autoComplete={autoComplete}
                          onBlur={onBlur}
                          placeholder={placeholder}
                          onFocus={selectOnFocus ? (e) => {
                              e.target.select();
                          } : undefined}
                          className={"input input-bordered w-full"} value={value} type={type} onChange={changed}/>
                      <span>{label}</span>
                  </label> :
                  <input
                      autoComplete={autoComplete}
                      onBlur={onBlur}
                      name={name}
                      placeholder={placeholder}
                      onFocus={selectOnFocus ? (e) => {
                          e.target.select();
                      } : undefined}
                      className={"input input-bordered w-full"} value={value} type={type} onChange={changed}/>
              }
          {
              maxLength &&
              <div>
                <small className="text-muted">{maxLength - (value || "").length} characters left</small>
              </div>
          }
      </Wrapper>
  );
}

function Wrapper({prefix, children, suffix}: {
    prefix?: string | React.ReactNode,
    suffix?: string | React.ReactNode,
    children: React.ReactNode,
    maxLength?: number
}){
  if(prefix || suffix){
    return <div className="input-group position-relative">
    {
        prefix && <span className="input-group-text">{prefix}</span>

    }
      {children}
    {
        suffix && <span className="input-group-text">{suffix}</span>
    }
  </div>
    }
  return children
}

export default Input;
